import React, { useEffect, useState } from 'react'
import pubsub from '@viewlift/pubsub'
import Popup from '../../../components/Account/Popup/Popup'
import { subscriptionData, getDiscountPrice, validateSubscriptionOfferCodeByPlanId } from '../../../MFEs/Monetization-Sdk/src/Api'
import { subscribeUpgradeSubscription, subscribeUpgradeViewplansPopup } from '../../Events/monetisation.events'
import { publishAppLoading, publishRedirect } from '../../Events/utils.events'
import { ANALYTICSEVENTS } from '../../LoginV2/Helpers/analyticsMap'
import { upgradePlan } from '../../MonetisationModule02/Stripe/helper'
import { fetchCurrentPlan, structuredPlan } from '../../PlansWrapper/helper'
import { getCurrencySymbol } from '../../../helpers'; 
import { getPlansById } from '../../Viewplans02/api';
import "./style.scss"

const UpgradeWrapper = ({ metadataMap, isViewplans }) => {
  const params = new URLSearchParams(window.location.search);
  const currentPlan = fetchCurrentPlan();
  const paramOffer = params.get('offer');
  const planId = params.get('planId');
  const [plan, setPlan] = useState(currentPlan);
  const [offer, setOffer] = useState(paramOffer);
  const [offerCodeDetails, setOfferCodeDetails] = useState({});
  const [offerCodeSuccess, setOfferCodeSuccess] = useState('');
  const [offerCodeError, setOfferCodeError] = useState('');
  const [validating, setValidating] = useState(false);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const [taxAmount, setTaxAmount] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [showModal, setShowModal] = useState({
    upgrade: {
      title: metadataMap?.upgradeSubscriptionPopupTitle || 'Upgrade Subscription?',
      modalState: false,
      description: metadataMap?.upgradeDescriptionText || 'Are your sure want to upgrade your subscription.'
    },
    status: {
      title: metadataMap?.successText || 'success',
      modalState: false,
      description: metadataMap?.upgradeSuccessMessage || 'subscription is upgraded'
    },
  })
  const [subscriptionFailed, setSubscriptionFailed] = useState(false);
  
  const disableCtaColor = "rgba(255, 255, 255, 0.3)";
  const activeCTAColor = "var(--siteCtaBackgroundColor)";
  const isOfferCodeDetail = Object.keys(offerCodeDetails).length;
  const paymentAmount = plan?.plansDetail?.recurringPaymentAmount;
  const currencyCode = plan?.plansDetail?.recurringPaymentCurrencyCode;

  const handlePlanClick = async () => {
    publishAppLoading(true)
    setShowModal({ ...showModal, upgrade: { ...showModal.upgrade, modalState: false } })
    let upgradePayload = {
      isUpgrade: true,
      data: {
        planId: plan?.planId,
        planIdentifier: plan?.identifier,
        platform: 'web_browser',
        subscription: 'stripe',
        appliedOffers: sessionStorage.getItem("offerCode") ? [sessionStorage.getItem("offerCode")] : null
      }

    }
    upgradePlan(upgradePayload)
    return
  }
  const handleUpgradeModal = (data) => {
    publishAppLoading(false)
    if (!data) {
      setSubscriptionFailed(true)
      setShowModal({ ...showModal, status: { ...showModal.status, modalState: true, title: metadataMap?.upgradeFailedText || 'upgrade Failed', description: metadataMap?.upgradeFailedMessage || 'unable to upgrade the subscription' } })
    } else {
      let planUpgradeEventData =  {
        "planId": plan?.planId,
        "planName": plan?.title,
        "planType": plan?.type
      }
      pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PLAN_UPDATE, data: planUpgradeEventData});
      setShowModal({ ...showModal, status: { ...showModal.status, modalState: true } })
    }
  }

  const fetchPlan = async() => {
    if (planId && !plan) {
      const plansRes = await getPlansById(planId, true);
      if (plansRes && plansRes?.length) {
        const plan = structuredPlan(plansRes[0]);
        setPlan(plan);
        sessionStorage.setItem('currentPlan', JSON.stringify(plan))
      }
    }
  }

  useEffect(() => {
    subscribeUpgradeViewplansPopup((data) => {
      setShowModal({ ...showModal, upgrade: { ...showModal.upgrade, modalState: true } });
      const currentPlan = fetchCurrentPlan();
      setPlan(currentPlan);
    });
    subscribeUpgradeSubscription(handleUpgradeModal)
    if(!isViewplans) setShowModal({ ...showModal, upgrade: { ...showModal.upgrade, modalState: true } })
    if (paramOffer) {
      sessionStorage.setItem('offerCode', paramOffer);
      onClickApply();
    }
    fetchPlan();
  }, [])


  const getActualPrice = async () => {
    const data = {
      id: plan?.planId,
      offerCode: offer?.toUpperCase(),
    };
    try {
      const res = await getDiscountPrice(data);
      if (res && res.data) {
        setDiscountedPrice(res.data.pretaxAmount);
        setTaxAmount(res.data.taxAmount);
        setTotalAmount(res.data.amount);
        setOfferCodeSuccess(metadataMap?.promoValidatingSuccess || 'Promo Code Applied Successfully');
        setTimeout(() => setOfferCodeSuccess(false), 5000);
      }
      publishAppLoading(false);
    } catch (err) {
      publishAppLoading(false);
      let offerStatus = err.response && err.response.data && err.response.data.code;
      let localizedError = metadataMap[offerStatus] || metadataMap?.promoValidatingError || "The Offer Code is already used";
      if (offerStatus === "OFFER_ALREADY_USED") {
        sessionStorage.removeItem("offerCode");
        sessionStorage.removeItem('promoCode');
      }
      setOfferCodeError(localizedError);
    }
  };

  const onClickApply = async (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    pubsub.publish('user-analytics', { ename: ANALYTICSEVENTS.APPLY_COUPON, data: { promotionCode: offerCode } });
    setValidating(true);
    publishAppLoading(true);
    
    const offerCode = offer?.toUpperCase();
    const planId = plan?.planId || '';
    sessionStorage.setItem('offerCode', offerCode);

    if (isOfferCodeDetail) {
      setValidating(false);
      publishAppLoading(false);
      return;
    }

    const offerValidatePayload = {
      offerCode: offerCode,
      subscriptionPlanId: planId,
      site: window?.app_data?.site?.siteInternalName,
    };

    const validateOfferResponse = await validateSubscriptionOfferCodeByPlanId(offerValidatePayload);
    if (!validateOfferResponse.isError && validateOfferResponse.data && validateOfferResponse.data.id) {
      setValidating(false);
      setOfferCodeDetails({
        displayName: validateOfferResponse.data.displayName,
        name: validateOfferResponse.data.name,
        code: offerCode,
      });
      setOffer(`${validateOfferResponse.data.displayName || validateOfferResponse.data.name || ''}`);
      getActualPrice();
    } else {
      setValidating(false);
      publishAppLoading(false);
      sessionStorage.removeItem('offerCode', offerCode);
      sessionStorage.removeItem('promoCode');
      setOfferCodeError(metadataMap?.promoValidatingError || 'Invalid Promo Code');
      setTimeout(() => setOfferCodeError(''), 5000);
    }
  };

  const removeCode = () => {
    publishAppLoading(true);
    params.delete("offer");
    sessionStorage.removeItem('offerCode');
    sessionStorage.removeItem('promoCode');
    setOfferCodeDetails({});
    setOffer('');
    setDiscountedPrice(null);
    setTaxAmount(null);
    setTotalAmount(null);
    setOfferCodeError('');
    publishAppLoading(false);
  };

  return (<>
    <div className='upgrade-wrapper'>
      <Popup
        show={showModal.upgrade.modalState}
        enableBtns={true}
        cancelHandler={() => publishRedirect("/")}
        confirmHandler={() => handlePlanClick()}
        title={showModal.upgrade.title}
        contentExtraPadding={true}
        contentAlignment='center'
        description={showModal.upgrade.description}
      >
        <div className="offer-container-upgrade-popup">
          {offerCodeSuccess && <div className="success-msg">{offerCodeSuccess}</div>}
          {offerCodeError && <div className="err-msg">{offerCodeError}</div>}
          <div className="plan-details">
            <h4>{plan?.plansDetail?.title}</h4>
            {discountedPrice ? (
              <div className="price-container">
                <span className="original-price">
                  {getCurrencySymbol(currencyCode)} {paymentAmount}
                </span>
                <span className="discounted-price">
                  {getCurrencySymbol(currencyCode)} {discountedPrice}
                </span>
              </div>
            ) : (
              <span >
                {getCurrencySymbol(currencyCode)}
                {paymentAmount}
              </span>
            )}
        </div>
        <div className="coupon-input">
          <input
            className={`offer-code-input ${isOfferCodeDetail > 0 ? "applied-code" : ""}`}
            placeholder={metadataMap?.addPromoPlaceholder || 'Add Promo'}
            onChange={(e) => {
              setOffer(e.target.value);
              setOfferCodeError(''); 
            }}
            onKeyPress={e => { if (e.key === 'Enter' && offer) onClickApply(e) }}
            value={offer}
            style={{ background: "transparent", color: "#000" }}
          />
          {isOfferCodeDetail > 0 && (
            <button
              aria-label="cancel"
              className="remove-code-btn site-cta-color site-cta-background-color"
              onClick={removeCode}
            >
              {metadataMap?.cancelPromo || 'Remove'}
            </button>
          )}
          {!offerCodeSuccess && isOfferCodeDetail === 0 && (
            <button
              disabled={!offer}
              style={!offer ? {background: `${disableCtaColor}`} : {background: activeCTAColor} }
              aria-label="apply"
              className={`apply site-cta-color ${validating ? 'processing' : ''}`}
              onClick={(e) => onClickApply(e)}
            >
              {validating ? metadataMap?.processingTxt || 'Processing' : metadataMap?.applyCode || 'Apply'}
            </button>
          )}
        </div>

        {discountedPrice && (
          <div className="discount-breakdown">
            <hr></hr>
            <div>
              <span>Discounted Price:</span>
              <div className="price-container">
                <span className="original-price">
                  {getCurrencySymbol(currencyCode)} {paymentAmount}
                </span>{" "}
                <span className="discounted-price">
                  {getCurrencySymbol(currencyCode)} {discountedPrice}
                </span>
              </div>
            </div>
            <div>
              <span>Tax:</span>
              <span>{getCurrencySymbol(currencyCode)} {taxAmount}</span>
            </div>
            <hr></hr>
            <div className="total-amount">
              <span>Total:</span>
              <span>{getCurrencySymbol(currencyCode)} {totalAmount}</span>
            </div>
          </div>
        )}
      </div>
      </Popup>
      <Popup
        show={showModal.status.modalState}
        enableBtns={true}
        confirmHandler={async () => {
          if (!subscriptionFailed) {
            await subscriptionData()
            publishAppLoading(false)
            publishRedirect("/")
          } else {
            publishRedirect("/")
          }
        }}
        cancelHandler={() => publishRedirect("/")}
        title={showModal.status.title}
        contentExtraPadding={true}
        contentAlignment='center'
        confirmCTA='Continue'
        description={showModal.status.description}
        options={{
          deleteConfig: { isDelete: true, isMessage: true }
        }}
      />
    </div>
  </>)
}

export default UpgradeWrapper